import { extractJsonFromText } from "./helper-string";

const parseErrorDetail = (detail: string): string => {
  const parsedDetail = extractJsonFromText(detail);
  if (parsedDetail?.error?.message) {
    return parsedDetail.error.message;
  }
  return detail;
};

export const getErrorMessage = (error: {
  detail?: string;
  userMessage?: string | string[];
}): string => {
  if (Array.isArray(error.userMessage)) {
    return `Erro ao salvar as informações: ${error.userMessage[0]}`;
  }

  if (error?.detail) {
    return `Erro ao salvar as informações: ${parseErrorDetail(error.detail)}`;
  }

  if (typeof error.userMessage === "string") {
    return `Erro ao salvar as informações: ${error.userMessage}`;
  }

  return "Erro ao salvar as informações";
};
